/*
 * @Author: your name
 * @Date: 2020-03-19 14:57:47
 * @LastEditTime: 2021-04-07 16:52:29
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /zhulogic-design-cloud-next/src/axios.js
 */
import axios from 'axios'
import ZhulogicModule from '../../zhulogic-module/packages/index'
import Store from './store'
import { API_BASE_URL } from './constants/index'
import { Token, GetTokenDark, ClearToken } from './utils/token'
import { OLD_BASIC_URL } from '@/constants'
import router from '@/router'

// axios 基础
axios.defaults.baseURL = API_BASE_URL
axios.defaults.timeout = 50000

// 请求
axios.interceptors.request.use(
  (config) => {
    // 按钮loading => true
    if (config.btn_loading) {
      Store.dispatch('matchButtonLoading', config.btn_loading)
    }
    Store.dispatch('startLoading')
    if (config.globalLoading) {
      Store.dispatch('startGlobalLoading')
    }
    if (Token()) {
      config.headers.Authorization = Token()
    }
    if (GetTokenDark()) {
      config.headers.dark = `${GetTokenDark()}`
    }
    return config
  },
  (error) => {
    Store.dispatch('errorLoading')
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  (response) => {
    Store.dispatch('stopLoading')
    if (response.config.globalLoading) {
      Store.dispatch('stopGlobalLoading')
    }
    // 按钮loading => false
    if (response.config.btn_loading) {
      Store.dispatch('relieveButtonLoading', response.config.btn_loading)
    }
    switch (response.data.status_code) {
      case 200:
        Store.dispatch('stopErrorLoading')
        return response.data.data
        break
      case 400:
        ZhulogicModule.Message.error(response.data.message)
        Store.dispatch('errorLoading')
        if (router.history.current.name === 'sign') {
          window.location = `${OLD_BASIC_URL}/`
        }
        return Promise.reject(response)
        break
      case 401:
        // 返回 401 清除token信息并跳转到登录页面
        ClearToken()
        router.replace({
          path: '/sign',
          query: { redirect: router.currentRoute.fullPath },
          hash: 'next',
        })
        return Promise.reject(response.data)
        break
      case 500:
        ZhulogicModule.Message.error('服务器出错了,稍后再试')
        Store.dispatch('errorLoading')
        return Promise.reject(response)
        break
      default:
        return {
          status_code: response.data.status_code,
          data: response.data.data,
        }
        return Promise.reject(response)
    }
    return response
  },
  (error) => {
    Store.dispatch('errorLoading')
    if (error.response) {
      return Promise.reject(error.response.data) // 返回接口返回的错误信息
    } else {
      ZhulogicModule.Message.destroy()
      ZhulogicModule.Message.error({
        content: '请求出错,请稍后再试',
        duration: 10,
        closable: true,
      })
      return Promise.reject('timeout')
    }
  }
)
